import api from './api';
import adminApi from './adminApi';

// ── Public catalog (no auth) ──────────────────────────────────
export const getCatalog      = (params = {}) => api.get('/api/wholesale/catalog', { params });
export const getProductBySlug = slug          => api.get(`/api/wholesale/catalog/${slug}`);

// ── Provider ordering (provider auth) ─────────────────────────
export const placeOrder      = data            => api.post('/api/wholesale/orders', data);
export const getMyOrders     = ()              => api.get('/api/wholesale/orders');
export const getOrder        = orderNumber     => api.get(`/api/wholesale/orders/${orderNumber}`);
export const cancelOrder     = orderNumber     => api.put(`/api/wholesale/orders/${orderNumber}/cancel`);

// ── Admin product management ──────────────────────────────────
export const getAdminProducts = ()             => adminApi.get('/wholesale/products');
export const createProduct    = data           => adminApi.post('/wholesale/products', data);
export const updateProduct    = (id, data)     => adminApi.put(`/wholesale/products/${id}`, data);
export const deleteProduct    = id             => adminApi.delete(`/wholesale/products/${id}`);

// ── Admin order management ────────────────────────────────────
export const getAdminOrders     = (params = {}) => adminApi.get('/wholesale/orders', { params });
export const getOrderStats      = ()            => adminApi.get('/wholesale/orders/stats');
export const updateOrderStatus  = (num, data)   => adminApi.put(`/wholesale/orders/${num}`, data);
